var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPointerUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ovals"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.303166,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#4FEDB4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2",
    opacity: 0.303166,
    cx: 30,
    cy: 30,
    r: 25,
    fill: "#4FEDB4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3",
    opacity: 0.303166,
    cx: 30,
    cy: 30,
    r: 20,
    fill: "#4FEDB4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_4",
    cx: 30,
    cy: 30,
    r: 9.5,
    fill: "#4FEDB4",
    stroke: "white",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPointerUser);
export default __webpack_public_path__ + "static/media/map_pointer_user.b885838acdc0db938fb1f869c6f70947.svg";
export { ForwardRef as ReactComponent };